// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".isi-content h4{color:#004e59;font-weight:700}.isi-content .iri-section{padding:0 0 1em}.isi-content .iri-section:first-of-type .inner-iri-section{border-bottom:1px solid #ababab;padding-bottom:1em}.isi-content h3{font-size:1.25em;font-weight:400;color:#004e59}.isi-content h4{font-size:1.15em}.isi-content .highlight{font-size:1.2em;font-weight:700}.isi-content a{color:#fce200;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
